import { ReactComponent as CheckIcon } from "../../../assets/icons/check.svg";
import { ReactComponent as WarningIcon } from "../../../assets/icons/warning-yellow.svg";
import { ReactComponent as InfoIcon } from "../../../assets/icons/information.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/closeCircleFilled.svg";
import "../../../css/Compliance/AML/Banners/Banner.css";

const Banner = ({ type = "", message }) => {
  const getIcon = () => {
    switch (type) {
      case "success":
        return <CheckIcon />;
      case "warning":
        return <WarningIcon />;
      case "info":
        return <InfoIcon />;
      case "error":
        return <CloseIcon />;
      default:
        return null;
    }
  };

  return (
    <div className={`AML-Banner ${type}`}>
      {getIcon()}
      <div className="FP_Content">{message}</div>
    </div>
  );
};

export default Banner;
